var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "nichibo-add-by-stockno",
        title: "Manually add nichibo stock"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ok, cancel, hide) {
            return [
              _vm.loading
                ? _c("div", { staticClass: "alert alert-info" }, [
                    _vm._v(
                      "\n            This can take up to 30 seconds depending on how many images there are.\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("icon", { attrs: { loading: _vm.loading } }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: {
                    size: "sm",
                    variant: "success",
                    disabled: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.onSubmit()
                    }
                  }
                },
                [_vm._v("\n            OK\n        ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.closeModal()
                    }
                  }
                },
                [_vm._v("\n            Cancel\n        ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "vehicle-stock-container" },
        [
          _c("p", [
            _vm._v(
              "\n            Please enter the Nichibo stock number below. This will search all nichibo users.\n        "
            )
          ]),
          _vm._v(" "),
          _c("messages", { attrs: { messages: _vm.messages, scroll: true } }),
          _vm._v(" "),
          _vm.vehicle_link
            ? _c("div", { staticClass: "alert alert-danger" }, [
                _c("a", { attrs: { href: _vm.vehicle_link } }, [
                  _vm._v("Vehicle link")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Nichibo Stock Number",
                "label-for": _vm.getId("nichibo_stock_number"),
                state: _vm.fieldState("nichibo_stock_number"),
                "invalid-feedback": _vm.invalidField("nichibo_stock_number")
              }
            },
            [
              _c("b-form-input", {
                ref: "stockNumber",
                attrs: {
                  id: _vm.getId("nichibo_stock_number"),
                  type: "number",
                  state: _vm.fieldState("nichibo_stock_number"),
                  placeholder: "Enter Stock Number"
                },
                model: {
                  value: _vm.nichibo_stock_number,
                  callback: function($$v) {
                    _vm.nichibo_stock_number = $$v
                  },
                  expression: "nichibo_stock_number"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63ff8684", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ff8684","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/CreateByNichiboStockNo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-63ff8684","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/CreateByNichiboStockNo.vue
// module chunks = 0